import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import GlossaryModal from './GlossaryModal';
import { getGlossaryTerm } from '../../utils/glossary';

const GlossaryTerm = ({ termKey, inline = false, children }) => {
  const [showModal, setShowModal] = useState(false);
  const term = getGlossaryTerm(termKey);

  if (!term) {
    return children || termKey;
  }

  if (inline) {
    return (
      <>
        <span className="glossary-term-inline">
          {children || term.term}
          <button
            className="glossary-icon"
            onClick={() => setShowModal(true)}
            aria-label={`Learn more about ${term.term}`}
            type="button"
          >
            <HelpCircle size={16} />
          </button>
        </span>
        {showModal && (
          <GlossaryModal term={term} onClose={() => setShowModal(false)} />
        )}
      </>
    );
  }

  return (
    <>
      <button
        className="glossary-button"
        onClick={() => setShowModal(true)}
        aria-label={`Learn more about ${term.term}`}
        type="button"
      >
        <HelpCircle size={18} />
      </button>
      {showModal && (
        <GlossaryModal term={term} onClose={() => setShowModal(false)} />
      )}
    </>
  );
};

export default GlossaryTerm;
